import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Reports = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="reports icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M17.769 0.787243L22.5315 1.09633C23.3325 1.14831 23.7489 2.07528 23.2557 2.7086L20.3236 6.47419C19.8606 7.06882 18.9312 6.95704 18.6224 6.26959L18.2768 5.5002L2.82907 12.4395C2.07339 12.779 1.1856 12.4416 0.846137 11.6859C0.506674 10.9302 0.844086 10.0424 1.59977 9.70296L17.0475 2.76363L16.792 2.19491C16.4832 1.50746 17.0169 0.738436 17.769 0.787243Z"
    />
    <path
      className={pathClass}
      d="M19 8.98202C17.8955 8.98202 17 9.87745 17 10.982V23.982H23V10.982C23 9.87745 22.1046 8.98202 21 8.98202H19Z"
    />
    <path
      className={pathClass}
      d="M9.00002 13.982C9.00002 12.8774 9.89545 11.982 11 11.982H13C14.1046 11.982 15 12.8774 15 13.982V23.982H9.00002V13.982Z"
    />
    <path
      className={pathClass}
      d="M1.00002 16.982C1.00002 15.8774 1.89545 14.982 3.00002 14.982H5.00002C6.10459 14.982 7.00002 15.8774 7.00002 16.982V23.982H1.00002V16.982Z"
    />
  </svg>
)
